// Resolves a file URL returned by the backend.
// - Absolute URLs (R2 public URLs) are returned as-is.
// - Relative URLs (local disk fallback, e.g. "/api/files/...") are prefixed
//   with the current origin so we stay same-host and avoid CORS/preflight
//   issues around domain canonicalisation (naked vs www).
export const resolveFileUrl = (fileUrl) => {
  if (!fileUrl) return "";
  if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
  const base =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    process.env.REACT_APP_BACKEND_URL ||
    "";
  return `${base}${fileUrl}`;
};
